import { MessageSquare, Sparkles, Users } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateSkillBasedRoutingAr: TemplateAr = {
  name: 'أتمتة التوجيه حسب المهارة بالذكاء الاصطناعي',
  description:
    'وجّه التذاكر للشخص المناسب في الفريق بناءً على محتوى التذكرة والخبرة المطلوبة وتوفّر الموظف.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'تذكرة' },
    { icon: Sparkles, label: 'تحليل ذكي' },
    { icon: Users, label: 'توجيه للمختص', final: true },
  ],
  detailDescription: {
    paragraph1:
      'وجّه كل تذكرة للموظف الأكفأ، مو للأول اللي يفضى. الـ AI يقرأ التذكرة، ويعرف وش المهارة اللي تحتاجها، ويطابقها مع الموظفين اللي عندهم الخبرة المناسبة والوقت وحجم العمل الملائم. ويحسب المعرفة التقنية، والخبرة بالمنتج، والمهارات اللغوية، والأداء السابق.',
    paragraph2:
      'قرارات التوجيه ونتائجها تلقاها في نظام التذاكر عندك، وتوصل لأدوات التحليل عشان تحسّنها. والـ AI يتعلّم من أنماط الحل ويرفع دقة التوجيه باستمرار. ومهارات الموظفين ومؤشرات أدائهم تتحدّث تلقائياً حسب نتائج التذاكر.',
  },
  benefits: [
    'كل تذكرة توصل للمختص من أول مرة',
    'وقت الحل ينزل وتلاحظ الفرق',
    'حجم العمل يتوزّع متوازناً على الفريق',
    'معدل الحل من أول تواصل يرتفع',
    'تتبّع مهارات موظفيك وتطوّرها',
    'دقة التوجيه تتحسّن باستمرار',
  ],
};
